import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

const getInitialLang = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem("siteLang") || (navigator.language.startsWith("nl") ? "nl" : "en");
  }
  return "en";
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(getInitialLang);

  const toggleLang = () => {
    const next = lang === "en" ? "nl" : "en";
    setLang(next);
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem("siteLang", next);
    }
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, nl: lang === "nl" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
